import { EffectDef, makeGain } from './types';

/** Smooth noise gate (AudioWorklet). Threshold is linear amplitude. */
export const gate: EffectDef = {
  type: 'gate',
  name: 'Noise Gate',
  params: [
    { key: 'threshold', label: 'Thresh', min: 0, max: 0.5, default: 0.05, step: 0.005 },
    { key: 'attack', label: 'Attack', min: 0.001, max: 0.2, default: 0.005, step: 0.001, unit: 's' },
    { key: 'release', label: 'Release', min: 0.01, max: 1, default: 0.12, step: 0.01, unit: 's' },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const node = new AudioWorkletNode(ctx, 'gate-processor');
    input.connect(node);
    node.connect(output);

    const apply = (params: Record<string, number>) => {
      node.port.postMessage({
        threshold: params.threshold,
        attack: params.attack,
        release: params.release,
      });
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        node.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};